import { graphql } from "@/gql";

export const createProDriverAgreementTemplate = graphql(`
  mutation CreateProDriverAgreementTemplateMutation(
    $input: CreateProDriverAgreementTemplateInput!
  ) {
    createProDriverAgreementTemplate(input: $input) {
      id
      name
      title
      body
      revision
      is_default
      created_at
      updated_at
      createdBy {
        id
        name
      }
    }
  }
`);

export const updateProDriverAgreementTemplate = graphql(`
  mutation UpdateProDriverAgreementTemplateMutation(
    $id: ID!
    $input: UpdateProDriverAgreementTemplateInput!
  ) {
    updateProDriverAgreementTemplate(id: $id, input: $input) {
      id
      name
      title
      body
      revision
      is_default
    }
  }
`);

export const archiveProDriverAgreementTemplate = graphql(`
  mutation ArchiveProDriverAgreementTemplateMutation($id: ID!) {
    archiveProDriverAgreementTemplate(id: $id) {
      id
      archived_at
    }
  }
`);

export const generateProDriverAgreementTemplatePdf = graphql(`
  mutation GenerateProDriverAgreementTemplatePdfMutation($id: ID!) {
    generateProDriverAgreementTemplatePdf(id: $id) {
      id
      url
      file_name
    }
  }
`);
